import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'clock-spinner',
  template: '<div class="clock-spinner"></div>',
  styleUrls: ['./clock-spinner.component.scss'],
  host: { '[attr.data-component-id]': '"clock-spinner"' }, // Уникальный атрибут для предотвращения дублирования
})
export class ClockSpinnerComponent {}
